/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Button, Alert, IconButton, Collapse  } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";

export default function UploadFile(props) {
  const { onDrop} = props;

  const [openAlert, setOpenAlert] = React.useState(true);

  const [errorMessage, setErrorMessage] = useState("");

  const onDropFitxers = useCallback(
    (acceptedFiles) => {
      const allowedFileTypes = [".png", ".jpg", ".jpeg", ".pdf", ".csv", ".xls", ".xlsx"];
      
      const invalidFileTypeFiles = acceptedFiles.filter(
        (file) => !allowedFileTypes.includes(`.${file.name.split(".").pop().toLowerCase()}`)
      );
  
      const invalidFileNameFiles = acceptedFiles.filter(
        (file) => file.name.length > 100
      );
  
      if (invalidFileTypeFiles.length > 0) {
        setErrorMessage("Només es permeten fitxers amb les extensions .png, .jpg, .jpeg, .pdf, .xls, .xlsx, .csv");
        setOpenAlert(true);
      } else if (invalidFileNameFiles.length > 0) {
        setErrorMessage("El nom del fitxer no pot ser superior a 100 caràcters");
        setOpenAlert(true);
      } else {
        setErrorMessage("");
        onDrop(acceptedFiles);
      }
    },
    [onDrop]
  );
  
  
  

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: false,
    noKeyboard: true,
    isDragActive: true,
    onDrop: onDropFitxers,
  });

  const styleDropzone = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: "2px",
    borderRadius: "2px",
    borderColor: "red",
    backgroundColor: "#F5F5F5",
    outline: "dashed #900000",
    fontFamily: "Arial",
    fontSize: 15,
    color: "#A0A0A0",
  };

  return (
    <div className="container">
    {errorMessage && (
      <Collapse in={openAlert}>
        <Alert 
            severity="error" 
            sx={{ marginTop: 2 }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpenAlert(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            >
              {errorMessage}
          </Alert>
      </Collapse>
      )}

      <div
        style={styleDropzone}
        onClick={open}
        {...getRootProps({ className: "dropzone" })}
      >
        <input {...getInputProps()} />
        <CloudUploadRoundedIcon fontSize="large" sx={{ color: "#900000" }} />
        <p>
          Arrossega els teus fitxers a aquesta àrea (.pdf, .png, .jpg, .xls, .xlsx o .csv).
        </p>
       
        <Button
          size={"small"}
          variant="contained"
          startIcon={<AddIcon />}
          sx={{
            marginTop: 3,
            color: "#900000",
            backgroundColor: "white",
            ":hover": { backgroundColor: "white" },
          }}
        >
          Seleccionar fitxers
        </Button>
        
      </div>
      
      <br></br>
    </div>
  );
}
